import axios from 'axios';
import semver from 'semver';
import packjson from '../../package.json';
import {router} from '../plugins/router/index';
import store from '../plugins/store/index';
import Encrypt from 'encryptlong';
import i18n from '../plugins/language/index';
const env = process.env.NODE_ENV;
const serverConfigs = {
    host: {
        development: 'localhost:8181',
        production: 'api.diantiyun.com'
    },
    wsProtocal: {
        development: 'ws://',
        production: 'wss://'
    }
}


let util = {};
util.context = null;
util.timer = false;
util.ossHeadBaseUrl = '';
util.title = function (title, vm) {
    // console.info('===init===> 页面初始化');
    util.context = vm;
    if (!title || typeof title !== 'string') title = "l.subtitle";
    let iTitle = i18n.tc('l.dty') + ' | ' + i18n.tc(title);
    window.document.title = iTitle;
};

const ajaxUrl = util.baseURL = `//${serverConfigs.host[env]}/`;
util.websocketURL = serverConfigs.wsProtocal[env] + serverConfigs.host[env];
util.axios = axios;
util.ajax = util.axios.create({
    baseURL: ajaxUrl,
    timeout: 60000,
});
util.ajax.defaults.headers.common.Authorization = localStorage.getItem('token') ? localStorage.getItem('token').toString() : "";
util.ajax.defaults.headers.common.language = localStorage.getItem('language')?localStorage.getItem('language'):"zh-CN";

// util.ajax.defaults.headers.common.winsuuid = localStorage.getItem('UUID') ? localStorage.getItem('UUID').toString() : '';

/**
 * 取消拦截器
 */
util.clearIntercepter = function () {
    // console.info('===clear===> 清除拦截器');
    util.ajax.interceptors.request.eject(util.reqIntercepter);
};

let getFormData = function (data) {
    if (!data) return data;
    let urlFormData = '';
    Object.keys(data).map((key) => {
        if (data[key] != null) {
            let value = data[key];
            if (typeof value === 'object') {
                value = JSON.stringify(value);
            }
            urlFormData += '&' + key + '=' + value;
        }
    });
    return urlFormData.slice(1);
};

let getStringValue = function (data) {
    if (!data) return data;
    let urlFormData = '';
    Object.keys(data).map((key) => {
        if (data[key] != null) {
            let value = data[key];
            if (typeof value === 'object') {
                data[key] = JSON.stringify(value);
            }
            // urlFormData += '&' + key + '=' + value;
        }
    });
    return data;
};

/**
 * 请求拦截器
 * @param resources
 */
util.setIntercepter = function (resources) {
    // console.info('===init===> 配置request拦截器');
    let uris = {};
    for (let key in resources) { // 遍历json对象的每个key/value对,p为key
        uris[key] = [];
        resources[key].map((res) => {
            uris[key].push(res.uri);
        });
    }
    util.reqIntercepter = util.ajax.interceptors.request.use((config) => {
        // console.info('===request===>', config.url, config)
        // 处理application/json 的请求
        // if (config.headers['Content-Type'] && config.headers['Content-Type'].includes('application/json') && typeof config.data === 'object') {
        //     config.data = JSON.stringify(config.data);
        // }
        // // 处理普通post/put请求
        if (config.method.toLowerCase() === 'post' || config.method.toLowerCase() === 'put') {
            if (config.data && !config.headers['Content-Type']) {
                config.data = getFormData(config.data);
            }
        } else {
            if (config.params && !config.headers['Content-Type']) {
                config.params = getStringValue(config.params);
            }
            if (config.data && !config.headers['Content-Type']) {
                config.data = getFormData(config.data);
            }
        }

        let token = util.ajax.defaults.headers.common.Authorization;
        // let lang = util.ajax.defaults.headers.common.lang;
        if (!token) {
            util.ajax.defaults.headers.common.Authorization = localStorage.getItem('token');
        }

        console.log("util.ajax.defaults.headers.common:",util.ajax.defaults.headers.common);
        // if (!lang){
        //     util.ajax.defaults.headers.common.lang = "zh";
        // }
        let isROOT = store.state.user.isROOT;// 超级管理员
        let commID = store.state.app.commID;// 当前小区ID

        if (isROOT) { // 超级管理员不拦截
            return config;
        } else {
            let uri = config.url.split('?')[0].replace(/[\\/]+/g, '/');
            // 系统权限包含uri 不拦截
            // 当前小区权限包含uri 不拦截
            // 登录接口不拦截
            let uri_split = uri.toLowerCase().split('/');
            let uriFun = uri_split[2];
            if (
                config.method.toUpperCase() === 'GET' ||
                uris.sys.includes(uri) ||
                (uris['c_' + commID] && uris['c_' + commID].includes(uri)) ||
                uri.includes('login') ||
                (uriFun && (uriFun.startsWith('get') || uriFun.startsWith('list') || uriFun.startsWith('query') || uriFun.startsWith('read') || uriFun.startsWith('check') || uriFun.startsWith('parse') || uriFun.endsWith('list')))
            ) {
                return config;
            }
            // console.warn('拦截uri：' + uri, config);
            util.context.$Message.warning(i18n.tc('l.no_permission'));
            return Promise.reject(new Error('no permission'));
        }
    });
};

util.inOf = function (arr, targetArr) {
    let res = true;
    arr.forEach(item => {
        if (targetArr.indexOf(item) < 0) {
            res = false;
        }
    });
    return res;
};

util.oneOf = function (ele, targetArr) {
    if (targetArr.indexOf(ele) >= 0) {
        return true;
    } else {
        return false;
    }
};

util.showThisRoute = function (itAccess, currentAccess) {
    if (typeof itAccess === 'object' && Array.isArray(itAccess)) {
        return util.oneOf(currentAccess, itAccess);
    } else {
        return itAccess === currentAccess;
    }
};

util.getRouterObjByName = function (routers, name) {
    if (!name || !routers || !routers.length) {
        return null;
    }
    // debugger;
    let routerObj = null;
    for (let item of routers) {
        if (item.name === name) {
            return item;
        }
        routerObj = util.getRouterObjByName(item.children, name);
        if (routerObj) {
            return routerObj;
        }
    }
    return null;
};

util.handleTitle = function (vm, item) {
    // if (typeof item.title === 'object') {
    //     return vm.$t(item.title.i18n);
    // } else {
    //     return item.title;
    // }
};

util.setCurrentPath = function (vm, name) {
    let title = '';
    let isOtherRouter = false;
    var token = localStorage.getItem("token");
    vm.$store.state.app.routers.forEach(item => {
        if (item.children.length === 1) {
            if (item.children[0].name === name) {
                title = util.handleTitle(vm, item);
                if (item.name === 'otherRouter') {
                    isOtherRouter = true;
                }
            }
        } else {
            item.children.forEach(child => {
                if (child.name === name) {
                    title = util.handleTitle(vm, child);
                    if (item.name === 'otherRouter') {
                        isOtherRouter = true;
                    }
                }
            });
        }
    });
    let currentPathArr = [];
    if (name === 'home_index') {
        currentPathArr = [
            {
                title: util.handleTitle(vm, util.getRouterObjByName(vm.$store.state.app.routers, 'home_index')),
                path: '',
                name: 'home_index'
            }
        ];
    } else if ((name.indexOf('_index') >= 0 || isOtherRouter) && name !== 'home_index') {
        currentPathArr = [
            {
                title: util.handleTitle(vm, util.getRouterObjByName(vm.$store.state.app.routers, 'home_index')),
                path: '/home',
                name: 'home_index'
            },
            {
                title: title,
                path: '',
                name: name
            }
        ];
    } else {
        let currentPathObj = vm.$store.state.app.routers.filter(item => {
            if (item.children.length <= 1) {
                return item.children[0].name === name;
            } else {
                let i = 0;
                let childArr = item.children;
                let len = childArr.length;
                while (i < len) {
                    if (childArr[i].name === name) {
                        return true;
                    }
                    i++;
                }
                return false;
            }
        })[0];
        if (currentPathObj.children.length <= 1 && currentPathObj.name === 'home') {
            currentPathArr = [
                {
                    title: i18n.tc('l.home'),
                    path: '',
                    name: 'home_index'
                }
            ];
        } else if (currentPathObj.children.length <= 1 && currentPathObj.name !== 'home') {
            currentPathArr = [
                {
                    title: i18n.tc('l.home'),
                    path: '/home',
                    name: 'home_index'
                },
                {
                    title: currentPathObj.title,
                    path: '',
                    name: name
                }
            ];
        } else {
            let childObj = currentPathObj.children.filter((child) => {
                return child.name === name;
            })[0];
            currentPathArr = [
                {
                    title: i18n.tc('l.home'),
                    path: '/home',
                    name: 'home_index'
                },
                {
                    title: currentPathObj.title,
                    path: '',
                    name: currentPathObj.name
                },
                {
                    title: childObj.title,
                    path: currentPathObj.path + '/' + childObj.path,
                    name: name
                }
            ];
        }
    }
    vm.$store.commit('setCurrentPath', currentPathArr);
    return currentPathArr;
};

util.openNewPage = function (vm, name, argu, query) {
    let pageOpenedList = vm.$store.state.app.pageOpenedList;
    let openedPageLen = pageOpenedList.length;
    let i = 0;
    let tagHasOpened = false;
    while (i < openedPageLen) {
        if (name === pageOpenedList[i].name) { // 页面已经打开
            vm.$store.commit('pageOpenedList', {
                index: i,
                argu: argu,
                query: query
            });
            tagHasOpened = true;
            break;
        }
        i++;
    }
    if (!tagHasOpened) {
        let tag = vm.$store.state.app.tagsList.filter((item) => {
            if (item.children) {
                return name === item.children[0].name;
            } else {
                return name === item.name;
            }
        });
        tag = tag[0];
        if (tag) {
            tag = tag.children ? tag.children[0] : tag;
            if (argu) {
                tag.argu = argu;
            }
            if (query) {
                tag.query = query;
            }
            // vm.$store.commit('increateTag', tag);
        }
    }
    vm.$store.commit('setCurrentPageName', name);
};

util.toDefaultPage = function (routers, name, route, next) {
    let len = routers.length;
    let i = 0;
    let notHandle = true;
    while (i < len) {
        if (routers[i].name === name && routers[i].children && routers[i].redirect === undefined) {
            route.replace({
                name: routers[i].children[0].name
            });
            notHandle = false;
            next();
            break;
        }
        i++;
    }
    if (notHandle) {
        next();
    }
};

util.fullscreenEvent = function (vm) {
    vm.$store.commit('initCachepage');
    // 权限菜单过滤相关
    // vm.$store.commit('updateMenulist');
    // 全屏相关
};

util.checkUpdate = function (vm) {
    axios.get('https://api.github.com/repos/iview/iview-admin/releases/latest').then(res => {
        let version = res.tag_name;
        vm.$Notice.config({
            duration: 0
        });
        if (semver.lt(packjson.version, version)) {
            vm.$Notice.info({
                title: 'iview-admin更新啦',
                desc: '<p>iView-admin更新到了' + version + '了，去看看有哪些变化吧</p><a style="font-size:13px;" href="https://github.com/iview/iview-admin/releases" target="_blank">前往github查看</a>'
            });
        }
    });
};

util.deepCopy = function (data) {
    if (typeof data === 'object') {
        return JSON.parse(JSON.stringify(data));
    }
    return data;
};

util.unique = function unique(arr) {
    return Array.from(new Set(arr))
}

//钥匙结构升序
util.orderKeys = function orderKeys(arr){
    if (!arr || !arr.length) return []
        return arr.sort((a,b)=>{
            return a.id-b.id;
        })
}
util.parseJSONResult = function (result, ...fields) {
    if (!result || typeof result !== 'object') return;
    else {
        Object.keys(result).forEach(key => {
            if (key.startsWith("j_") || (fields && fields.includes(key))) {
                try {
                    result[key] = JSON.parse(result[key]); // j_monitor_config
                } catch (e) {

                }
            }
        })
    }
}

util.packResLayer = function (list) {
    let layer1 = [];
    let layer2 = [];
    let layer3 = [];

    //        分层
    list.map((res) => {
        switch (res.layer) {
            case 1:
                res.children = [];
                layer1.push(res);
                break;
            case 2:
                res.children = [];
                layer2.push(res);
                break;
            case 3:
                layer3.push(res);
                break;
        }
    });
    //        封装第二层
    this.putLayer(layer2, layer3);
    //        封装外层
    this.putLayer(layer1, layer2);

    return layer1;
};


util.putLayer = function (parents, children) {
    parents.map((p) => {
        let id = p.id;
        children.map((c) => {
            if (c.pid == id) {
                p.children.push(c);
            }
        });
    });
};
util.formatDate = function (fmt, date) {
    // author: meizz
    var o = {
        'M+': date.getMonth() + 1, // 月份
        'd+': date.getDate(), // 日
        'h+': date.getHours(), // 小时
        'm+': date.getMinutes(), // 分
        's+': date.getSeconds(), // 秒
        'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
        'S': date.getMilliseconds() // 毫秒
    };
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    for (var k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)));
        }
    }
    return fmt;
};
util.getDate = function (time) {
    if (time != null) {
        return time.split(' ')[0];
    } else {
        return '';
    }
};
util.parseJSON = function (inn, instead) {
    if (inn === 'null') return instead;
    if (inn) {
        if (typeof inn === 'string') {
            try {
                return JSON.parse(inn);
            } catch (e) {
                return instead;
            }
        } else if (typeof inn === 'object') {
            return inn;
        } else {
            return instead
        }
    } else {
        return instead;
    }
};
let initDateFormatter = function () {
    /** * 对Date的扩展，将 Date 转化为指定格式的String * 月(M)、日(d)、12小时(h)、24小时(H)、分(m)、秒(s)、周(E)、季度(q)
     可以用 1-2 个占位符 * 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字) * eg: * (new
     Date()).pattern("yyyy-MM-dd hh:mm:ss.S")==> 2006-07-02 08:09:04.423
     * (new Date()).pattern("yyyy-MM-dd E HH:mm:ss") ==> 2009-03-10 二 20:09:04
     * (new Date()).pattern("yyyy-MM-dd EE hh:mm:ss") ==> 2009-03-10 周二 08:09:04
     * (new Date()).pattern("yyyy-MM-dd EEE hh:mm:ss") ==> 2009-03-10 星期二 08:09:04
     * (new Date()).pattern("yyyy-M-d h:m:s.S") ==> 2006-7-2 8:9:4.18
     */
    Date.prototype.pattern = function (fmt) {
        var o = {
            'M+': this.getMonth() + 1, // 月份
            'd+': this.getDate(), // 日
            'h+': this.getHours() % 12 == 0 ? 12 : this.getHours() % 12, // 小时
            'H+': this.getHours(), // 小时
            'm+': this.getMinutes(), // 分
            's+': this.getSeconds(), // 秒
            'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
            'S': this.getMilliseconds() // 毫秒
        };
        var week = {
            '0': '/u65e5',
            '1': '/u4e00',
            '2': '/u4e8c',
            '3': '/u4e09',
            '4': '/u56db',
            '5': '/u4e94',
            '6': '/u516d'
        };
        if (/(y+)/.test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
        }
        if (/(E+)/.test(fmt)) {
            fmt = fmt.replace(RegExp.$1, ((RegExp.$1.length > 1) ? (RegExp.$1.length > 2 ? '/u661f/u671f' : '/u5468') : '') + week[this.getDay() + '']);
        }
        for (var k in o) {
            if (new RegExp('(' + k + ')').test(fmt)) {
                fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)));
            }
        }
        return fmt;
    };
    // console.info('===init===> 初始化时间格式化函数pattern');
};
let tologin = function (code) {
    if (store.state.app.isMobile){
        router.push({name: 'm_login'});
        if (code){
            util.context.$Message.error(
                i18n.tc('l.Login_failure'),
                i18n.tc(`l.${code}`)
            );
        }
    } else{
        router.push({name: 'login'});
        if (code){
            util.context.$Message.warning({
                title: i18n.tc('l.Login_failure'),
                content:i18n.tc(`l.${code}`)
            });
        }
    }

};

// 设置密码
const toSetPasswordPage = function (){
    if (store.state.app.isMobile){

    } else{
        router.push({name: 'set_pwd_page'});
    }
};
const toSetMobilePage = function (){
    router.push({name: 'set_mobile_page'});
};



/**
 * 配置response拦截
 */
let setResponseIntercepter = function () {
    // console.info('===init===> 配置response拦截器');
    util.resIntercepter = util.ajax.interceptors.response.use((config) => {


        if (config.data && config.data.code) { // 错误会进到这里
            if (config.data.code === 401||config.data.code === 402||config.data.code === 403) {
                tologin(config.data.code);
                return;
            }

            if(config.data.code == 413){  //  413 密码过于简单错误   2024年6月4日  王欢
                toSetPasswordPage();
                return ;
            }
            if(config.data.code == 415){  //  413 密码过于简单错误   2024年6月4日  王欢
                toSetMobilePage();
                return ;
            }


            if (config.data.code === -100){
                util.context.$Message.destroy();
            }
            // if (config.data.code==-2)  return config.data // 特殊错误  直接处理
            if (config.data.msg && config.data.msg.length > 0) {
                if (util.context) {
                    if (config.data.code > 10000) {
                        util.context.$Modal.error({
                            title: i18n.tc(`l.error`),
                            content: config.data.msg
                        });
                    } else { // 错误码小于10000  40开头的直接提示，根据错误码以及中英文
                            util.context.$Message.error(i18n.tc(`l.${config.data.code}`));
                    }
                }
            }else{
                util.context.$Message.error(i18n.tc(`l.${config.data.code}`));
            }
            return Promise.resolve(config.data);
        }
        return config.data;
    });
};

util.getUUID = function () {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    })
};
util.toEndTime = function (time) {
    let date = time.replace("-", "")
    let endTime = date.replace("-", "")
    return endTime
};

util.compareTime = function (time1) {
    if ("" == time1) return false
    var newTime = time1.slice(0, 4) + "-" + time1.slice(4, 6) + "-" + time1.slice(6, 8)
    var oDate1 = new Date(newTime);  //数据库得到的日期
    var oDate2 = new Date()
    return oDate1.getTime() >= oDate2.getTime()
}


/**
 * 请求权限资源
 */

util.getAuth = function (force) {
    let token = localStorage.getItem('token');
    if (!token || token === 'null') {
        return;
    }
    util.ajax.defaults.headers.common.Authorization = token;
    return util.ajax.get('/getuser', {params: {refresh: force ? 1 : 0}}).then((res) => {
        let user = res.data;
        if (user){
             store.commit('setUser', user);
             store.commit('setMenuList'); // 通过权限 设置能访问的 Pag
            if (!user.current_company) {
                util.chooseCurrentCompany(); // 当前角色没有所属公司，必须让他选择
            }
        }
        else tologin(402);
    }).catch(err => {
        util.context.$router.push({
            replace: true,
            name: 'error-net'
        });
    });
};
util.getSystemSettings = function () {

}
util.chooseCurrentCompany = function () {
    let companyid = 0;
    util.context.$Modal.confirm({
        title: i18n.tc('l.chooseCompany'),
        render: (h) => {
            let doms = store.state.user.user.companies.map(company => h('Radio', {
                props: {
                    label: company.id
                }
            }, company.name))
            return h('RadioGroup', {
                on: {
                    'on-change': (value) => {
                        companyid = value;
                    }
                }
            }, doms)
        },
        onOk: function () {
            window.location.reload(true);
            util.setCompany(companyid, true);
        }
    })
}
util.setCompany = function (id, afterGetAuth) {
    return util.ajax.put('/user/setcompany', {
        id: id
    }).then(res => {
        if (!res.code) {
            store.commit('setUserCompany', id);
        }
    })
}
util.initVideoPageSize = function (isCallHelp,socketId,ifMobile) {
    // var video_cell = document.getElementsByClassName("video-cell")
    var other_video = document.getElementsByClassName("other-video")
    var room = document.getElementById("video-room-"+socketId)
    if (other_video) {
        if (isCallHelp){
            for (let i = 0; i < other_video.length; i++) {
                other_video[i].style.width = '400px';
                other_video[i].style.height = '400px';
            }
            if (room){
                room.style.color = '#fff'
                room.style.fontWeight = 'bold'
                room.style.position = 'relative'
                if (ifMobile){
                    room.style.left='20px'
                    room.style.bottom='40px'
                } else{
                    room.style.right='20px'
                    room.style.bottom='390px'
                }
            } else{

            }
        } else{
            for (let i = 0; i < other_video.length; i++) {
                other_video[i].style.width = '100%';
                other_video[i].style.maxHeight = '400px';
            }
        }

    }
//
}
util.stringToByte = function(str) {
    var bytes = new Array();
    var len, c;
    len = str.length;
    for(var i = 0; i < len; i++) {
        c = str.charCodeAt(i);
        if(c >= 0x010000 && c <= 0x10FFFF) {
            bytes.push(((c >> 18) & 0x07) | 0xF0);
            bytes.push(((c >> 12) & 0x3F) | 0x80);
            bytes.push(((c >> 6) & 0x3F) | 0x80);
            bytes.push((c & 0x3F) | 0x80);
        } else if(c >= 0x000800 && c <= 0x00FFFF) {
            bytes.push(((c >> 12) & 0x0F) | 0xE0);
            bytes.push(((c >> 6) & 0x3F) | 0x80);
            bytes.push((c & 0x3F) | 0x80);
        } else if(c >= 0x000080 && c <= 0x0007FF) {
            bytes.push(((c >> 6) & 0x1F) | 0xC0);
            bytes.push((c & 0x3F) | 0x80);
        } else {
            bytes.push(c & 0xFF);
        }
    }
    return bytes;


}
util.byteToString = function(arr) {
    if (typeof arr === 'string') {
        return arr;
    }
    var str = '',
        _arr = arr;
    for (var i = 0; i < _arr.length; i++) {
        var one = _arr[i].toString(2),
            v = one.match(/^1+?(?=0)/);
        if (v && one.length == 8) {
            var bytesLength = v[0].length;
            var store = _arr[i].toString(2).slice(7 - bytesLength);
            for (var st = 1; st < bytesLength; st++) {
                store += _arr[st + i].toString(2).slice(2);
            }
            str += String.fromCharCode(parseInt(store, 2));
            i += bytesLength - 1;
        } else {
            str += String.fromCharCode(_arr[i]);
        }
    }
    return str;
}

util.encrypt = function(str, sessionData) {
    if (str.length > 128) {
        while (str.length) {

        }
    }
    var encrypt = new Encrypt();
    encrypt.setPublicKey(sessionData.session_key);
    return encrypt.encrypt(sessionData.iv + str);
}





util.init = function () {
    util.getAuth();
};
setResponseIntercepter();
initDateFormatter();
export default util;